import { Heart, Building2 } from "lucide-react";

const FoundationTab = () => {
  return (
    <div className="space-y-6">
      <div className="bg-white border border-slate-200/60 rounded-2xl p-6">
        <div className="flex items-start justify-between mb-6">
          <div>
            <h3 className="text-lg font-semibold text-slate-900">Foundation Settings</h3>
            <p className="text-sm text-slate-500 mt-1">
              Configure charitable giving and foundation features for your organization
            </p>
          </div>
          <div className="w-12 h-12 bg-rose-100 rounded-2xl flex items-center justify-center">
            <Heart className="w-6 h-6 text-rose-600" />
          </div>
        </div>
        
        <div className="text-center py-12 bg-slate-50 rounded-2xl">
          <Building2 className="w-12 h-12 text-slate-300 mx-auto mb-3" />
          <p className="text-slate-500 mb-2">Foundation features coming soon</p>
          <p className="text-sm text-slate-400">
            This section will allow you to manage charitable giving programs and foundations
          </p>
        </div>
      </div>
    </div>
  );
};

export default FoundationTab;
